import { type MouseEvent } from "react";
import ButtonWithLoader from "@/components/ui/button-with-loader.tsx";
import { type ButtonProps } from "@/components/ui/button.tsx";
import useDownloadFiles from "../hooks/use-download-files.ts";

type Props = Omit<ButtonProps, "asChild"> & { onSuccess?: () => void };

export default function DownloadTrigger({ children, onClick, onSuccess, ...props }: Props) {
    const { mutate, isPending } = useDownloadFiles(onSuccess);

    const handleClick = (evt: MouseEvent<HTMLButtonElement>) => {
        onClick?.(evt);
        mutate();
    };

    return (
        <ButtonWithLoader {...props} isLoading={isPending} onClick={handleClick}>
            {children}
        </ButtonWithLoader>
    );
}
